<mat-toolbar *ngIf="!currentUser" [class.darkHeader]="selectedCommunity?.dark_header"
             [style.background-color]="loginNavColour"
             class="d-flex mat-elevation-z3 flex-space-between "
             color="primary">
    <div>
        <button *ngIf="companyImg  && (!selectedCommunity?.login_page_top_logo_hidden || !this.isLogin)"
                [routerLinkActive]="'mat-accent'" [routerLink]="['/dashboard']"
                aria-label="Feed"
                class="logoBg logoBtn" mat-icon-button>
            <img [src]="companyImg" class="companyImg ">
        </button>
    </div>

    <button *ngIf="selectedCommunity && !selectedCommunity?.retired_community && (listItems.length > 0  || selectedCommunity?.terms_and_conditions || selectedCommunity?.privacy_policy)"
            #menuOption="matMenuTrigger" [matMenuTriggerFor]="menu" aria-label="Menu"
            (menuOpened)="menuOption.menuOpen" (menuClosed)="menuOption.menuOpen"
            [style.color]="this.themeService.getReadableColor(loginNavColour? loginNavColour : loginNavColour|| primaryColor)"
            aria-label="Menu"
            class="tabletShow show"
            mat-icon-button matTooltip="More menu items">
        <i>
            <svg viewBox="0 0 100 80" width="40" height="40"
                 [@openClose]="menuOption.menuOpen ? 'open' : 'closed'"
                 (@openClose.done)="onAnimationDone(menuOption.menuOpen)" [class.openedBurger]="menuOpen">
                <rect width="100" height="10" rx="8"></rect>
                <rect y="30" width="100" height="10" rx="8"></rect>
                <rect y="60" width="100" height="10" rx="8"></rect>
            </svg>
        </i>
    </button>
    <mat-menu #menu="matMenu">
        <button *ngIf="selectedCommunity?.terms_and_conditions" [routerLink]="['/terms-and-conditions']" mat-menu-item>
            <span>Terms & Conditions</span>
        </button>
        <button *ngIf="selectedCommunity?.privacy_policy" [routerLink]="['/privacy-policy']" mat-menu-item>
            <span>Privacy Policy</span>
        </button>
        <ng-container *ngFor="let item of listItems">
            <button *ngIf="item.show_on_login_page" [routerLink]="['/info', item.id]" mat-menu-item>
                {{ item.title }}
            </button>
        </ng-container>
        <button *ngIf="!loggedIn" [routerLink]="['/login']" mat-menu-item>
            <span>Login</span>
        </button>
    </mat-menu>
</mat-toolbar>
<app-authview-header *ngIf="currentUser"/>

<div [style.background-color]="this.backgroundColour" [style.background-image]="'url(' + backgroundImage + ')'"
     class="minFullHeight">
    <div [class.webview]="isWebView" class="control">
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
    <app-footer></app-footer>
</div>


